import { BitrixVue } from 'ui.vue';
/*
 * теперь этот файл/поток будет кодироваться в UTF-8
 */
//
BitrixVue.component('DoubleInputNumeric', {
	data() {
		return {
			currentMinValue: this.minValue,
			currentMaxValue: this.maxValue,
		};
	},
	props: ['state', 'minValue', 'maxValue', 'label'],
	methods: {
		setOnlyNumber(e) {
			e.target.value = e.target.value.replace(/\D/, '');
		},
	},
	template: `
	<div class="config-field__block">
			<div v-if="this.label" class="config-select__title">{{this.label}}</div>
			<div class="config-double config-double__doormodel-price">
					<div class="config-double__block">
							<div class="config-double__fly">от</div>
							<input class="config-double__input config-input__doormodel-minprice" 
							v-model.number="currentMinValue" 
							:value="currentMinValue"
							@input="$emit('doubleInputValueChanged', [currentMinValue, currentMaxValue])"
							>
					</div>
					<div class="config-double__block">
							<div class="config-double__fly">до</div>
							<input class="config-double__input config-input__doormodel-maxprice" 
							v-model.number="currentMaxValue" 
							:value="currentMaxValue"
							@input="$emit('doubleInputValueChanged', [currentMinValue, currentMaxValue])"
							>
					</div>
			</div>
	</div>
`,
});
